<template lang="pug">
  div
    h2 Har Har
    pre {{joke}}
</template>

<script>

export default {
  name: 'Joke',
  components: {
  },
  data () {
    return {
      joke: `Q. There are 500 bricks on a plane, one falls off, how many left?

A. 499

Q. What are the 3 simple steps of putting an elephant in a refrigerator?

A. Open refrigerator, put elephant in, close refrigerator.

Q. What are the 4 simple steps of putting a giraffe in a refrigerator?

A. Open refrigerator, take elephant out, put giraffe in, close refrigerator.

Q. It’s the lions birthday and he invites everyone in the jungle. Everyone turns up but one animal, what animal is it and why?

A. The giraffe, he’s in the refrigerator.

Q. Sally is an explorer. She is walking through a jungle when suddenly she comes across a crocodile infested river. There are no bridges over it. Sally swims over and is not bitten by a single crocodile. How?

A. All the crocodiles are at the lions party.

Q. Sally dies anyway, why?

A. She is hit in the head by a brick.
`
    }
  }
}
</script>


<style lang="stylus" scoped>
  pre
    padding 20px
    white-space break-spaces
</style>